/*
  UNEND (ticket 1b70266c): link "Ver tudo" no cabecalho da vitrine com abas (sections/featured-collections.liquid).
  O link fica na mesma linha das abas e passa a apontar para a colecao da aba escolhida.
  As URLs de cada aba vem em data-links, separadas por "|", na mesma ordem das abas.
*/
(() => {
  const ligar = (link) => {
    if (link.dataset.unendPronto) return;
    link.dataset.unendPronto = '1';

    const links = (link.dataset.links || '').split('|');
    const cabecalho = link.closest('.unend-sec-head');
    const nav = cabecalho ? cabecalho.querySelector('.featured-collections-navigation') : null;
    if (!nav) return;

    const botoes = Array.from(nav.children).filter((el) => el.tagName === 'BUTTON');

    const atualizar = () => {
      const ativo = botoes.findIndex((botao) => botao.getAttribute('aria-current') === 'true');
      const url = links[ativo] || links[0];
      if (url) link.setAttribute('href', url);
    };

    new MutationObserver(atualizar).observe(nav, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    atualizar();
  };

  const iniciar = (raiz) => {
    (raiz || document).querySelectorAll('[data-unend-ver-tudo]').forEach(ligar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => iniciar());
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', (event) => iniciar(event.target));
})();
